import React from 'react'
import { Box } from '@mui/material'
import Dialog from './Dialog'
import { useCustomTranslation } from '../../Hooks/useCustomTranslation'
import { Trans } from 'react-i18next'

export interface InformationDialogProps {
  textKey: string
  title: string
  buttonText?: string
  onClose: () => void
}

/**
 * Dialog to display plain information about something with no further interaction
 * @param title - The title of the dialog
 * @param textKey - The key of the text to display (using a  key here to support linebreaks by default)
 * @param buttonText - The text of the button to close the dialog
 */
const InformationDialog: React.FC<InformationDialogProps> = ({ title, textKey, buttonText, onClose }) => {
  const { t } = useCustomTranslation()

  return (
    <Dialog onClose={onClose} title={title} actions={{ primary: { name: buttonText ?? t('common.close'), onClick: onClose } }}>
      <Trans
        i18nKey={textKey}
        components={{
          break: <Box component="br" />,
        }}
      />
    </Dialog>
  )
}

export default InformationDialog
